var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationScribbleHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 88 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.34 116C13.164 90.772 1.49 62.834 3.16 33.958c.624-10.946 3.751-22.726 12.61-29.19 1.564-1.146 3.335-2.084 5.212-1.667 2.188.417 3.543 2.502 4.585 4.378a125.882 125.882 0 0114.696 42.533c7.4-13.76 19.178-25.02 33.352-31.691 2.085-.938 4.378-1.877 6.566-1.355 5.211 1.25 5.524 8.652 4.065 13.76-9.068 33.88-36.166 59.525-62.014 83.189"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationScribbleHeart);
export default __webpack_public_path__ + "static/media/illustration-scribble-heart.f68f1f0355c4ca2c82883510184093d1.svg";
export { ForwardRef as ReactComponent };